import { useCallback, useEffect, useState } from "react";
import { SendMessage } from "../../protocol";

interface LogInWithSessionProps {
  onSendMessage(message: SendMessage): void;
  defaultClientAccessId: string;
}

export const LogInWithSession: React.FC<LogInWithSessionProps> = props => {
  const { onSendMessage } = props;

  const [clientAccessId, setClientAccessId] = useState("");
  const [sessionToken, setSessionToken] = useState("");

  useEffect(() => {
    setClientAccessId(props.defaultClientAccessId);
  }, [props.defaultClientAccessId])

  const handleLogInWithSession: React.FormEventHandler = useCallback(e => {
    e.stopPropagation();
    e.preventDefault();

    onSendMessage({
      message: "log-in-with-session",
      clientAccessId,
      sessionToken,
    });
  }, [onSendMessage, clientAccessId, sessionToken]);

  return (
    <details>
      <summary>Log In with Session <strong>(Unstable)</strong></summary>
      <p><strong>This message is not recommended for production use, as the interface may change.</strong></p>
      <p><strong>Note:</strong> In this demo app, the session token will be logged in your browser's Web Inspector console and under "Show Message History"</p>
      <form onSubmit={handleLogInWithSession}>
        <label>
          <p>Client Access ID</p>
          <input type="text" value={clientAccessId} onChange={e => setClientAccessId(e.target.value)} />
        </label>
        <label>
          <p>Session Token</p>
          <input type="password" value={sessionToken} onChange={e => setSessionToken(e.target.value)} />
        </label>
        <button type="submit">Sign In</button>
      </form>
    </details>
  );
}
